import script from "./MyWorkOrderFinished.vue?vue&type=script&setup=true&lang=js"
export * from "./MyWorkOrderFinished.vue?vue&type=script&setup=true&lang=js"

import "./MyWorkOrderFinished.vue?vue&type=style&index=0&id=2724ef69&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2724ef69"]])

export default __exports__